/**
 * Constants
 */
/** @hidden */
export var cellClick = 'cellClick';
/** @hidden */
export var cellDoubleClick = 'cellDoubleClick';
/** @hidden */
export var moreEventsClick = 'moreEventsClick';
/** @hidden */
export var select = 'select';
/** @hidden */
export var hover = 'hover';
/** @hidden */
export var actionBegin = 'actionBegin';
/** @hidden */
export var actionComplete = 'actionComplete';
/** @hidden */
export var actionFailure = 'actionFailure';
/** @hidden */
export var navigating = 'navigating';
/** @hidden */
export var renderCell = 'renderCell';
/** @hidden */
export var eventClick = 'eventClick';
/** @hidden */
export var eventRendered = 'eventRendered';
/** @hidden */
export var dataBinding = 'dataBinding';
/** @hidden */
export var dataBound = 'dataBound';
/** @hidden */
export var popupOpen = 'popupOpen';
/** @hidden */
export var popupClose = 'popupClose';
/** @hidden */
export var dragStart = 'dragStart';
/** @hidden */
export var drag = 'drag';
/** @hidden */
export var dragStop = 'dragStop';
/** @hidden */
export var resizeStart = 'resizeStart';
/** @hidden */
export var resizing = 'resizing';
/** @hidden */
export var resizeStop = 'resizeStop';
/**
 * Specifies schedule internal events
 */
/** @hidden */
export var initialLoad = 'initial-load';
/** @hidden */
export var initialEnd = 'initial-end';
/** @hidden */
export var dataReady = 'data-ready';
/** @hidden */
export var eventsLoaded = 'events-loaded';
/** @hidden */
export var contentReady = 'content-ready';
/** @hidden */
export var scroll = 'scroll';
/** @hidden */
export var virtualScroll = 'virtual-scroll';
/** @hidden */
export var scrollUiUpdate = 'scroll-ui-update';
/** @hidden */
export var uiUpdate = 'ui-update';
/** @hidden */
export var documentClick = 'document-click';
/** @hidden */
export var cellMouseDown = 'cell-mouse-down';
